/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestCheckSellerIdRequest
 */
export interface RequestCheckSellerIdRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestCheckSellerIdRequest
     */
    userId?: number;
}

/**
 * Check if a given object implements the RequestCheckSellerIdRequest interface.
 */
export function instanceOfRequestCheckSellerIdRequest(value: object): value is RequestCheckSellerIdRequest {
    return true;
}

export function RequestCheckSellerIdRequestFromJSON(json: any): RequestCheckSellerIdRequest {
    return RequestCheckSellerIdRequestFromJSONTyped(json, false);
}

export function RequestCheckSellerIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCheckSellerIdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function RequestCheckSellerIdRequestToJSON(json: any): RequestCheckSellerIdRequest {
    return RequestCheckSellerIdRequestToJSONTyped(json, false);
}

export function RequestCheckSellerIdRequestToJSONTyped(value?: RequestCheckSellerIdRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
    };
}

